import { createApp } from '@app/adapters/create-app'
import CompanyInbox from '@app/application/communication/screens/inbox/components/company-inbox.vue'
import createInboxStore from '@app/application/communication/screens/inbox/store/inbox'
import InboxFilters from '@app/application/communication/screens/inbox/components/inbox-filters.vue'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='company-inbox']").each(function () {
    const endpointParams = {
      companyId: Silverfin.currentCompanyId,
      ledgerId: Silverfin.currentLedgerId(),
      firmId: Silverfin.currentFirmId,
    }

    const companyInboxApp = createApp(CompanyInbox, {
      initialCategory: $(this).data('category'),
      initialItem: $(this).data('item'),
    })
    const store = createInboxStore(endpointParams)

    companyInboxApp.use(store)
    companyInboxApp.mount(this)

    $dom.find("[data-behaviour='inbox-filters']").each(function () {
      const filtersApp = createApp(InboxFilters, {
        showAuthorsFilter: true,
        initialSearch: $(this).data('search') || '',
        initialNoteType: $(this).data('noteType') || null,
        initialAuthors:
          $(this)
            .data('authors')
            ?.toString()
            ?.split(',')
            ?.map((value) =>
              value === 'external' ? value : Number.parseInt(value)
            ) || [],
        initialTags:
          $(this).data('tags')?.toString()?.split(',')?.map(Number.parseInt) ||
          [],
      })
      filtersApp.use(store)
      filtersApp.mount(this)
    })
  })
})
